<template>
    <div class="con">
        <el-row>
            <el-col :span="24">
                <el-alert title="" type="success"><h1>晴川专升本考试系统安全运维可视化</h1></el-alert>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-card class="box-card" style="width: 100%">
                    <div slot="header" class="clearfix">
                        <span>报名统计</span>
                        <el-button style="float: right; padding: 3px 0" type="text" @click="censusStudent">刷新</el-button>
                    </div>
                    <div class="text item">
                        <div>
                            <el-date-picker
                                v-model="time1"
                                size="mini"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                @change="censusStudent"
                                :picker-options="pickerOptions"
                                :editable="true">
                            </el-date-picker>
                        </div>
                        <ve-histogram :data="chartData" :extend="chartExtend"  :toolbox="toolbox" :settings="chartSettings" :data-zoom="dataZoom"></ve-histogram>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-card class="box-card" style="width: 100%">
                    <div slot="header" class="clearfix">
                        <span>各专业报名统计</span>
                        <el-button style="float: right; padding: 3px 0" type="text" @click="censusRegistByMajor">刷新</el-button>
                    </div>
                    <div>
                        <div>
                            <el-date-picker
                                    v-model="time3"
                                    size="mini"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    @change="censusRegistByMajor"
                                    :picker-options="pickerOptions"
                                    :editable="true">
                            </el-date-picker>
                        </div>
                        <ve-ring :data="majorStateData" :settings="sexSettings"></ve-ring>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-card class="box-card" style="width: 100%">
                    <div slot="header" class="clearfix">
                        <span>{{year}}学校总录取率</span>
                        <el-button style="float: right; padding: 3px 0" type="text" @click="getPercent">刷新</el-button>
                    </div>
                    <div>
                        <div>
                            <el-date-picker
                                size="mini"
                                v-model="year"
                                type="year"
                                placeholder="选择年"
                                value-format="yyyy"
                                format="yyyy"
                                @change="getPercent"
                                :editable="true">
                            </el-date-picker>
                        </div>
                        <div style="text-align: center;margin: auto">
                            <ve-liquidfill :data="percentData" style="margin:0 auto" width="200px" height="200px" :settings="percentSettings" ></ve-liquidfill>
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-card class="box-card" style="width: 100%">
                    <div slot="header" class="clearfix">
                        <span>{{year}}各专业总录取率</span>
                        <el-button style="float: right; padding: 3px 0" type="text" @click="censusMajorPesonal">刷新</el-button>
                    </div>
                    <div>
                        <div>
                            <el-date-picker
                                    size="mini"
                                    v-model="year1"
                                    type="year"
                                    placeholder="选择年"
                                    value-format="yyyy"
                                    format="yyyy"
                                    @change="censusMajorPesonal"
                                    :editable="true">
                            </el-date-picker>
                        </div>
                        <ve-histogram :data="majorPesonalData" :extend="chartExtend"  :toolbox="toolbox" :settings="majorSettings"></ve-histogram>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-card class="box-card" style="width: 100%">
                    <div slot="header" class="clearfix">
                        <span>录取性别统计</span>
                        <el-button style="float: right; padding: 3px 0" type="text" @click="censusAdmissionBySex">刷新</el-button>
                    </div>
                    <div>
                        <div>
                            <el-date-picker
                                    v-model="time2"
                                    size="mini"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    @change="censusAdmissionBySex"
                                    :picker-options="pickerOptions"
                                    :editable="true">
                            </el-date-picker>
                        </div>
                        <ve-ring :data="sexStateData" :settings="sexSettings"></ve-ring>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    import axios from "axios";
    import ElRow from "element-ui/packages/row/src/row";
    export default {
        components: {ElRow},
        name: "door",
        data(){
            this.dataZoom = [
                {
                    type: 'slider',
                    start: 0,
                    end: 100
                }
            ];
            this.chartSettings = {
                labelMap: {
                    'value': '注册报名个数',
                },
            };
            this.majorSettings = {
                labelMap: {
                    'value': '录取率',
                },
            };
            this.chartExtend={
                barWidth : 25,
            };
            this.sexSettings = {
                radius: [50, 100],
                offsetY: 160,
                itemStyle: {
                    borderWidth:10,
                    borderColor:'#fff',
                },
            };
            this.toolbox = {
                feature: {
                    saveAsImage: {
                    }
                },
                right:30,
                top:0,
            };
            this.percentSettings = {
                wave:[],
                seriesMap: {
                    '总录取率': {
                        radius:'80%',
                        label: {
                            fontSize: 14,
                        },
                        outline:{
                            show:false
                        }
                    }
                }
            };
            return{
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                time1:[],
                time2:[],
                time3:[],
                chartData: {
                    columns: ['name', 'value'],
                    rows: [
                    ]
                },
                sexStateData:{
                    columns: ['name', 'value'],
                    rows: []
                },
                majorStateData:{
                    columns: ['name', 'value'],
                    rows: []
                },
                percentData: {
                    columns: ['city', 'percent'],
                    rows: [{
                        city: '总录取率',
                        percent: 0.3
                    }]
                },
                majorPesonalData:{
                    columns: ['name', 'value'],
                    rows: []
                },
                year:new Date().getFullYear()+"",
                year1:new Date().getFullYear()+""
            }
        },
        created(){
            this.censusStudent();
            this.censusAdmissionBySex();
            this.censusRegistByMajor();
            this.getPercent();
            this.censusMajorPesonal();
        },
        mounted(){

        },
        methods: {
            censusStudent(){
                if(this.time1.length==0){
                    const end = new Date();
                    const start = new Date();
                    this.time1[0] = start.getFullYear()+"-"+(start.getMonth()<10?"0"+start.getMonth():start.getMonth())+"-"+(start.getDate()<10?"0"+start.getDate():start.getDate());
                    this.time1[1] = end.getFullYear()+"-"+((end.getMonth()+1)<10?"0"+(end.getMonth()+1):(end.getMonth()+1))+"-"+(end.getDate()<10?"0"+end.getDate():end.getDate());
                }
                axios({
                    url:`${home}/census/censusStudent`,
                    method:'POST',
                    params:{
                        "startTime":this.time1[0],
                        "endTime":this.time1[1],
                    }
                }).then(res=>{
                    this.chartData.rows = res.data;
                }).catch(error=>{

                })
            },
            censusAdmissionBySex(){
                if(this.time2.length==0){
                    const end = new Date();
                    const start = new Date();
                    this.time2[0] = start.getFullYear()+"-"+(start.getMonth()<10?"0"+start.getMonth():start.getMonth())+"-"+(start.getDate()<10?"0"+start.getDate():start.getDate());
                    this.time2[1] = end.getFullYear()+"-"+((end.getMonth()+1)<10?"0"+(end.getMonth()+1):(end.getMonth()+1))+"-"+(end.getDate()<10?"0"+end.getDate():end.getDate());
                }
                axios({
                    url:`${home}/census/censusAdmissionBySex`,
                    method:'POST',
                    params:{
                        "startTime":this.time2[0],
                        "endTime":this.time2[1],
                    }
                }).then(res=>{
                    this.sexStateData.rows = res.data;
                }).catch(error=>{

                })
            },
            censusRegistByMajor(){
                if(this.time3.length==0){
                    const end = new Date();
                    const start = new Date();
                    this.time3[0] = start.getFullYear()+"-"+(start.getMonth()<10?"0"+start.getMonth():start.getMonth())+"-"+(start.getDate()<10?"0"+start.getDate():start.getDate());
                    this.time3[1] = end.getFullYear()+"-"+((end.getMonth()+1)<10?"0"+(end.getMonth()+1):(end.getMonth()+1))+"-"+(end.getDate()<10?"0"+end.getDate():end.getDate());
                }
                axios({
                    url:`${home}/census/censusRegistByMajor`,
                    method:'POST',
                    params:{
                        "startTime":this.time3[0],
                        "endTime":this.time3[1],
                    }
                }).then(res=>{
                    this.majorStateData.rows = res.data;
                }).catch(error=>{

                })
            },
            getPercent(){
                axios({
                    url:`${home}/census/getPercent`,
                    method:'POST',
                    params:{
                        "year":this.year
                    }
                }).then(res=>{
                    this.percentData.rows[0].percent = res.data;
                }).catch(error=>{

                })
            },
            censusMajorPesonal(){
                axios({
                    url:`${home}/census/censusMajorPesonal`,
                    method:'POST',
                    params:{
                        "year":this.year1
                    }
                }).then(res=>{
                    this.majorPesonalData.rows = res.data;
                }).catch(error=>{

                })
            },
        }
    }
</script>

<style scoped lang="scss">
    .el-row{
        margin-bottom: 10px;
    }
    .con{
        padding: 10px;
    }
    .text {
        font-size: 14px;
    }

    .item {
        margin-bottom: 18px;
    }
    .clearfix::after {
        display: table;
        content: "";
        clear: both;
    }

    .box-card {
        width: 480px;
    }
    .active{
        background-color: #c0ccda;
    }
</style>